// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__aGjsM","loader":"Loader_loader__gPW3M"};